import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { ChangePasswordComponent } from './membership/change-password/change-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './forgot-password/reset-password/reset-password.component';
import { RedirectComponent } from './redirect/redirect.component';
import { ProspectsComponent } from './membership/prospects/prospects.component';
 
const routes: Routes = [
  {
    path:"",
    component : LoginComponent
  },
  {
    path:"redirect/:type",
    component : RedirectComponent
  },
  {
    path:"change-password",
    component : ChangePasswordComponent
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent
  },
  {
    path: "reset-password/:id/:token",
    component: ResetPasswordComponent,
  },
  {
    path:"restaurants",
    loadChildren: () => import('./membership/restaurants/restaurants.module').then(m => m.RestaurantsModule),
    canActivate:[AuthGuard],
  },
  {
    path:"settings",
    loadChildren: () => import('./membership/settings/settings.module').then(m => m.SettingsModule),
    canActivate:[AuthGuard],
  },
  {
    path:"drivers",
    loadChildren: () => import('./membership/drivers/drivers.module').then(m => m.DriversModule),
    canActivate:[AuthGuard],
  },
  {
    path:"activity",
    loadChildren: () => import('./membership/activity/activity.module').then(m => m.ActivityModule),
    canActivate:[AuthGuard],
  },
  {
    path:"activity-details/:id/:batchNo",
    loadChildren: () => import('./membership/activity-details/activity-details.module').then(m => m.ActivityDetailsModule),
    canActivate:[AuthGuard],
  },
  {
    path:"region-map",
    loadChildren: () => import('./membership/region-map/region-map.module').then(m => m.RegionMapModule),
    canActivate:[AuthGuard],
  },
  {
    path:"accounts",
    loadChildren: () => import('./membership/accounts/accounts.module').then(m => m.AccountsModule),
    canActivate:[AuthGuard],
  },
  {
    path:"shift-planner",
    loadChildren: () => import('./membership/shiftplanner/shiftplanner.module').then(m => m.ShiftplannerModule),
    canActivate:[AuthGuard],
   },
  {
    path:"alerts",
    loadChildren: () => import('./membership/alert/alert.module').then(m => m.AlertModule),
    canActivate:[AuthGuard],
   },
   {
    path: "prospects",
    component: ProspectsComponent,
    canActivate:[AuthGuard],
   }
];

@NgModule({
  imports: [RouterModule.forRoot(routes),],
  exports: [RouterModule]
})
export class AppRoutingModule { }
